import { KeyValueModel, ModelBase } from "./ModelBase"

export class UtenteModel extends ModelBase {
    Id: string
    Nominativo: string
    Email: string
    Username: string
    Password: string
}

export class RuoloClienteModel
{
    Id: string
    Ruolo: string
    Cliente: string
}

export class UtenteViewModel extends UtenteModel
{
    RuoloClientiList: Array<RuoloClienteModel>
}

export class RuoloClienteInputModel extends ModelBase
{
    IdUtente: string
    Ruolo: string
    Cliente: string
    Ufficio: string
}

export class RuoloClienteViewModel extends RuoloClienteInputModel
{
    RuoloList: Array<KeyValueModel>
    ClientiList: Array<KeyValueModel>
    UfficiList: Array<KeyValueModel>
}

export class ConnectorConfigModelBase extends ModelBase {
    
    ClienteId: string
    Periodo: string
    NrPeriodo: string
    Connettore: string
    PeriodoList: Array<KeyValueModel>
    NrPeriodoList: Array<string>
    ConnettoreList: Array<KeyValueModel>
}

export class ConfigFattureModel extends ConnectorConfigModelBase {
    IdApp: string
    KeyApp: string
}

export class ConfigOpenBankingModel extends ConnectorConfigModelBase {
    // todo
    
}